import { makeStyles } from "tss-react/mui"
import { Grid, Skeleton } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    container: {
        gap: "1.25rem",
    },
}))
export function AgreementSkeleton() {
    const { classes } = useStyles()

    return (
        <>
            <Grid container wrap="nowrap" alignItems="center" className={classes.container}>
                <Skeleton width="10%" height={30} />
                <Skeleton width="20%" height={50} />
            </Grid>
            <Grid container direction="column" wrap="nowrap" className={classes.container}>
                <Skeleton width="80%" height={20} />
                <Skeleton width="70%" height={20} />
            </Grid>
            <Skeleton width="50%" height={40} />
        </>
    )
}
